import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {
  type LanguageQualificationFormData,
  type GetLanguageQualification,
} from './types';
import { checkInvalidDate } from '../checkInvalidDate';

const LANGUAGE_QUALIFICATION = gql`
  query ($id: ID!) {
    languageQualification(id: $id) {
      needEnglishTest
      testType
      testDate
      expectedResultUpdateDate
      resultAnnouncedIndicator
      referenceNo
      result {
        resultReceiptDate
        listening
        reading
        writing
        speaking
        overall
      }
      supportingDocuments {
        id
        link
        name
      }
    }
  }
`;

export const useGetLanguageQualificationFormData = (
  id: string,
): GetLanguageQualification => {
  const {
    data: languageQualificationData,
    loading,
    error,
  } = useQuery(LANGUAGE_QUALIFICATION, {
    variables: { id },
    skip: !id,
    fetchPolicy: 'network-only',
  });

  const {
    needEnglishTest,
    result,
    resultAnnouncedIndicator = false,
    testDate,
    expectedResultUpdateDate,
    testType = '',
    referenceNo = '',
    supportingDocuments = [],
  } = languageQualificationData?.languageQualification ?? {};

  const { resultReceiptDate, ...scores } = result ?? {};

  const languageQualificationFormData: LanguageQualificationFormData = {
    testType,
    testDate: checkInvalidDate(testDate) ? null : String(testDate),
    resultReceiptDate: checkInvalidDate(resultReceiptDate)
      ? null
      : String(resultReceiptDate),
    expectedResultUpdateDate: checkInvalidDate(expectedResultUpdateDate)
      ? null
      : String(expectedResultUpdateDate),
    resultAnnouncedIndicator: resultAnnouncedIndicator ?? false,
    ...((resultAnnouncedIndicator as boolean) ? { ...scores } : {}),
    referenceNo,
    supportingDocuments,
    needEnglishTest,
  };

  return { languageQualificationFormData, loading, error };
};
